// @flow
import { Textarea } from '@rebass/forms';

export default Textarea;
